import {
	createRootRoute,
	createRouter,
	createRoute,
	AnyRoute,
} from '@tanstack/react-router';

import { basepath } from '@/constants';
import { IssueView } from '@/views/issue/Issue';
import { NotFound, RootRouteComponent } from '@/views/RootRoute';
import { Preview } from '../starmagazine/preview/Preview';

import { Home } from './home/Home';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

/* Routes declaration */

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: Home,
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: IssueView,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	validateSearch: issueSearchSchema,
	component: IssueView,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Preview,
	path: 'preview/$id',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issueRoute,
	issueArticleRoute,
	previewRoute,
];

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
